import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { createAuth } from './auth/auth';
import { loadRuntimeConfig } from './config';
import './styles.css';

const root = createRoot(document.getElementById('root')!);

loadRuntimeConfig().then(
  (config) =>
    root.render(
      <StrictMode>
        <App auth={createAuth(config)} apiBase={config.apiBase} />
      </StrictMode>,
    ),
  (error: unknown) =>
    root.render(
      <p role="alert">Configuration error: {error instanceof Error ? error.message : 'unknown'}</p>,
    ),
);
